import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import TabBar from '../../../../../../component/tab-bar/tab-bar';
import { CourseWithGrades } from '../../types';
import { GradesTab } from './components/grades-tab';
import { LecturesTab } from './components/lectures-tab';
import { AssignmentsTab } from './components/assignments/assignments-tab';
import { ExamsTab } from './components/exams/exams-tab';

interface GradeDialogProps {
  visible: boolean;
  onHide: () => void;
  selectedCourse: CourseWithGrades | null;
}

const tabs = ['מפגשים', 'מרכיבי הציון' /*, 'מטלות', 'מבחנים'*/];

export const GradeDialog: React.FC<GradeDialogProps> = ({
  visible,
  onHide,
  selectedCourse,
}) => {
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  if (!selectedCourse) return null;

  const tabComponents = [
    <LecturesTab key="lectures" selectedCourse={selectedCourse} />,
    <GradesTab key="grades" selectedCourse={selectedCourse} />,
    /*<AssignmentsTab key="assignments" selectedCourse={selectedCourse} />,
    <ExamsTab key="exams" selectedCourse={selectedCourse} />,*/
  ];

  return (
    <Dialog
      header={`פירוט ציונים - ${selectedCourse.courseName}`}
      visible={visible}
      style={{ width: '90%', maxWidth: '1400px' }}
      className="grade-dialog"
      onHide={onHide}
      dismissableMask
      draggable={false}
      resizable={false}
    >
      <TabBar tabs={tabs} onClick={(index) => setSelectedTabIndex(index)} />

      <div style={{ marginTop: '16px' }}>{tabComponents[selectedTabIndex]}</div>
    </Dialog>
  );
};
